import PropTypes from "prop-types";
import React from "react";
import { editDeleteStyles } from "../../../globals";
import Modal from "../../Modal/Modal";
import STSComponent from "../../STSComponent/STSComponent";

class ListModal extends STSComponent {
  constructor(props) {
    super(props);
    this.deleteConfirm = this.deleteConfirm.bind(this);
    this.bringEditItemScreen = this.bringEditItemScreen.bind(this);
  }

  deleteConfirm = (item) => () => {
    const { openModal, modalType, sendData } = this.props;
    sendData(item);
    openModal(`Delete-${modalType}`)();
  };

  bringEditItemScreen = (item) => () => {
    const { sendData, openModal, modalType } = this.props;
    sendData(item);
    openModal(`Edit-item-${modalType}`)();
  };

  returnListItem = () => {
    const { listArray, itemText, modalType, hideEditDelete } = this.props;
    const { deleteConfirm, bringEditItemScreen } = this;
    if (!listArray) return null;
    return listArray.map((item, i) => {
      let newItem = "";
      for (let i = 0; i < itemText.length; i++) {
        newItem = `${newItem} ${item[itemText[i]]}`;
      }
      const itemSubName =
        modalType === "user"
          ? item.FirstName + item.LastName
          : modalType === "contact"
          ? item.ContactName
          : typeof itemText === "string"
          ? item[itemText]
          : newItem;
      return (
        <div
          className={`modal-row ${
            itemText.includes("Agency") ? "small-modal-row" : ""
          }`}
          key={i}
        >
          <span
            className={`${
              hideEditDelete ? "wide-subject-items" : "subjects-items"
            }`}
          >
            {itemSubName}
          </span>
          {hideEditDelete ? (
            ""
          ) : (
            <div className="edit-controls">
              <span
                className="form-text-subtitle-clickable-section edit-btn"
                onClick={bringEditItemScreen(item)}
              >
                EDIT
              </span>
              <span> / </span>
              <span
                className="form-text-subtitle-clickable-section delete-btn"
                onClick={deleteConfirm(item)}
              >
                DELETE
              </span>
            </div>
          )}
        </div>
      );
    });
  };

  render() {
    const {
      modalType,
      title,
      toAddNew,
      toClose,
      content,
      btnArea,
      addNewBtn,
      customStyles,
      hideEditTitle,
      modal,
    } = this.props;
    return (
      <Modal
        modalType={`List-${modalType}`}
        contentLabel={`List-${modalType}`}
        customStyles={editDeleteStyles[customStyles || "edit"]}
        modal={modal}
      >
        <div className="get-report-modals-titlearea">
          <span className="get-report-modals-title">
            {!hideEditTitle ? "Edit " : null} {title}
            {title === "subject" ||
            title === "favorite" ||
            title === "contact" ||
            title === "user"
              ? "s"
              : null}
          </span>
        </div>
        <div className="background-white">
          <div className="get-report-list-container custom-scroll">
            {content || (
              <div className="flex-container subjects-wrap local-locality-wrap">
                {this.returnListItem()}
              </div>
            )}
          </div>
        </div>
        {btnArea || (
          <div className="get-report-modals-buttons-area buttonsarea-type2 modal-buttons-area">
            <button className="btn-modal-bg" onClick={toAddNew}>
              Add new {addNewBtn || title}
            </button>
            <button onClick={toClose}>Close</button>
          </div>
        )}
      </Modal>
    );
  }

  static propTypes = {
    modalType: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    toClose: PropTypes.func,
    toAddNew: PropTypes.func,
    openModal: PropTypes.func,
    listArray: PropTypes.array,
    itemText: PropTypes.any,
    sendData: PropTypes.func,
    content: PropTypes.node,
    btnArea: PropTypes.node,
    addNewBtn: PropTypes.string,
    customStyles: PropTypes.string,
    hideEditTitle: PropTypes.bool,
    hideEditDelete: PropTypes.bool,
    modal: PropTypes.object,
  };
}

export default ListModal;



// WEBPACK FOOTER //
// ./src/components/Modal/components/ListModal.js